<div class="w-full max-w-200" data-tour-id="automatyczne-adnotacje">
  <!-- Master -->
  <div class="grid sm:grid-cols-4 gap-6">
    <div class="sm:col-span-2">
      <div class="flex-auto">
        <div class="leading-6 font-semibold">Automatyczne adnotacje dla nowych dokumentów</div>
        <div class="text-md text-secondary">
          Przy tworzeniu nowego dokumentu automatycznie zaznaczaj wybrane adnotacje i ustawiaj ich domyślne wartości
        </div>
      </div>
    </div>
    <div class="sm:col-span-2 flex items-start">
      <mat-slide-toggle
        [(ngModel)]="autoAnnotations"
        (change)="onMasterToggle($event.checked)"
        color="primary"
        [disabled]="isProcessing">
        {{ autoAnnotations ? 'Włączone' : 'Wyłączone' }}
      </mat-slide-toggle>
    </div>
  </div>

  <!-- Pod-ustawienia (widoczne tylko gdy master włączony) -->
  <div *ngIf="autoAnnotations" class="mt-6 space-y-6">

    <!-- Domyślna procedura marży -->
    <div class="grid sm:grid-cols-4 gap-6">
      <div class="sm:col-span-2">
        <div class="flex-auto">
          <div class="leading-6 font-semibold">Domyślna procedura marży</div>
          <div class="text-md text-secondary">Automatycznie zaznaczaj procedurę marży i wybieraj jej rodzaj</div>
        </div>
      </div>
      <div class="sm:col-span-2">
        <mat-slide-toggle
          [(ngModel)]="defaultMarginProcedureEnabled"
          (change)="onMarginProcedureToggle($event.checked)"
          color="primary"
          [disabled]="isProcessing">
          {{ defaultMarginProcedureEnabled ? 'Włączone' : 'Wyłączone' }}
        </mat-slide-toggle>

        <mat-form-field *ngIf="defaultMarginProcedureEnabled" class="w-full mt-3">
          <mat-label>Rodzaj procedury marży</mat-label>
          <mat-select
            [(ngModel)]="defaultMarginProcedureId"
            (ngModelChange)="onMarginProcedureChange($event)"
            [disabled]="isProcessing">
            <mat-option *ngFor="let proc of marginProcedures" [value]="proc.id">
              {{ proc.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Domyślny mechanizm podzielonej płatności (MPP) -->
    <div class="grid sm:grid-cols-4 gap-6">
      <div class="sm:col-span-2">
        <div class="flex-auto">
          <div class="leading-6 font-semibold">Domyślny mechanizm podzielonej płatności (MPP)</div>
          <div class="text-md text-secondary">
            Automatycznie zaznaczaj split payment i wybieraj konto VAT z kont bankowych
          </div>
        </div>
      </div>
      <div class="sm:col-span-2">
        <mat-slide-toggle
          [(ngModel)]="defaultSplitPayment"
          (change)="onSplitPaymentToggle($event.checked)"
          color="primary"
          [disabled]="isProcessing">
          {{ defaultSplitPayment ? 'Włączone' : 'Wyłączone' }}
        </mat-slide-toggle>

        <!-- Wybrane konto VAT -->
        <div *ngIf="defaultSplitPayment && vatAccount"
             class="mt-3 rounded-lg border border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/20 p-3">
          <div class="flex items-center gap-2 text-green-700 dark:text-green-300 text-sm font-medium">
            <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:receipt-tax'"></mat-icon>
            Konto VAT: {{ vatAccount.bank || 'Konto bankowe' }}
          </div>
          <div class="mt-1 font-mono text-sm tracking-wider text-gray-700 dark:text-gray-300">
            {{ formatAccountNumber(vatAccount.accountNumber) }}
          </div>
        </div>

        <!-- Ostrzeżenie: brak konta VAT -->
        <div *ngIf="showMissingVatAccountWarning"
             class="mt-3 rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 p-3">
          <div class="flex items-start gap-2 text-amber-700 dark:text-amber-300 text-sm">
            <mat-icon class="icon-size-4 mt-0.5" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
            <span>
              Nie masz skonfigurowanego konta VAT w kontach bankowych. MPP zostanie zaznaczony,
              ale numer konta VAT nie zostanie uzupełniony automatycznie.
            </span>
          </div>
          <a mat-stroked-button color="primary"
             class="mt-3"
             [routerLink]="['/konto/moje-konto/dane-konta']"
             [fragment]="'konta-bankowe'">
            <mat-icon [svgIcon]="'tabler_outline:building-bank'"></mat-icon>
            <span class="ml-2">Skonfiguruj konto VAT</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Zwolnienie z VAT -->
    <div class="grid sm:grid-cols-4 gap-6">
      <div class="sm:col-span-2">
        <div class="flex-auto">
          <div class="leading-6 font-semibold">Podstawa zwolnienia z VAT</div>
          <div class="text-md text-secondary">Domyślna podstawa prawna dla pozycji ze stawką "zw." (zgodna z KSeF)</div>
        </div>
      </div>
      <div class="sm:col-span-2">
        <mat-slide-toggle
          [(ngModel)]="defaultVatExemptionEnabled"
          (change)="onVatExemptionToggle($event.checked)"
          color="primary"
          [disabled]="isProcessing">
          {{ defaultVatExemptionEnabled ? 'Włączone' : 'Wyłączone' }}
        </mat-slide-toggle>

        <ng-container *ngIf="defaultVatExemptionEnabled">
          <mat-form-field class="w-full mt-3">
            <mat-label>Typ podstawy prawnej</mat-label>
            <mat-select
              [(ngModel)]="selectedExemptionType"
              (ngModelChange)="onExemptionTypeChange($event)"
              [disabled]="isProcessing">
              <mat-option [value]="null">Brak domyślnej</mat-option>
              <mat-option *ngFor="let type of vatExemptionTypes" [value]="type.type">
                {{ type.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="selectedExemptionType" class="w-full mt-1">
            <mat-label>Podstawa prawna</mat-label>
            <textarea
              matInput
              [(ngModel)]="exemptionLegalBasis"
              (blur)="onLegalBasisBlur()"
              rows="3"
              [placeholder]="selectedTypePlaceholder"
              [disabled]="isProcessing">
            </textarea>
          </mat-form-field>

          <div class="mt-1">
            <mat-slide-toggle
              [(ngModel)]="showVatExemptionBase"
              (change)="onShowVatExemptionChange($event.checked)"
              color="primary"
              [disabled]="isProcessing">
              Podstawa zwolnienia na dokumencie
            </mat-slide-toggle>
          </div>
        </ng-container>
      </div>
    </div>

  </div>
</div>
